
function Wings(opt) {
    let defaultOptions = {
        canvasId: 'test-wings-canvas',
        audioId: 'test-wings-audio',
        audioNegativeId: 'test-wings-negative-audio',
        imageTop: 0,         // the top-left corner when drawing the image
        imageLeft: 0,    
        imageWidth: 580,     // this is the content image width and height
        imageHeight: 400,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        imagesPrefix: null,
        imagesStartNumber: 0,
        imagesEndNumber: 0,
        imagesNumberLength: 0,
        stillDuration: 0, // the last frame as still frame duration in milliseconds
        audioUrl: 'audios/add-score.mp3',
        audioNegativeUrl: 'audios/add-score-negative.mp3',
    };
    this.options = Object.assign({}, defaultOptions, opt ? opt : {});
    this.images = [];
    this.imagesNegative = [];
    this.images03 = [];
    this.images46 = [];
    this.images710 = [];
    this.q = [];
    this.isAnimating = false;

    this.canvas = null;
    this.audio = null;
    this.audioNegative = null;

    this.init();
    
}

/**
 * Init the DOM components
 * and load the resources
 */
Wings.prototype.init = function() {
    this.preload();

    let canvasElement = document.getElementById(this.options.canvasId);
    if ( ! canvasElement) {
        canvasElement = document.createElement('canvas'); 
        canvasElement.setAttribute('id', this.options.canvasId);
        canvasElement.setAttribute('width', window.innerWidth);
        canvasElement.setAttribute('height', window.innerHeight);
        canvasElement.style.width = window.innerWidth + 'px';
        canvasElement.style.height = window.innerHeight + 'px';
        canvasElement.style.position = 'fixed';
        canvasElement.style.left = 0;
        canvasElement.style.top = 0;
        canvasElement.style.display = 'none';
        document.body.appendChild(canvasElement);
        
    }
    
    this.options.imageLeft = (window.innerWidth - this.options.imageWidth) / 2;
    this.options.imageTop  = (window.innerHeight - this.options.imageHeight) / 2;
    
    window.addEventListener('resize', () => {
        canvasElement.setAttribute('width', window.innerWidth);
        canvasElement.setAttribute('height', window.innerHeight);
        canvasElement.style.width = window.innerWidth + 'px';
        canvasElement.style.height = window.innerHeight + 'px';
        this.options.imageLeft = (window.innerWidth - this.options.imageWidth) / 2;
        this.options.imageTop  = (window.innerHeight - this.options.imageHeight) / 2;
    });
    
    this.canvas = canvasElement;

    let audioElement = document.getElementById(this.options.audioId);
    if ( ! audioElement) {
        audioElement = document.createElement('audio');
        audioElement.setAttribute('id', this.options.audioId);
        audioElement.setAttribute('src', this.options.audioUrl);
        audioElement.setAttribute('preload', true);
        // audioElement.setAttribute('autoplay', true);
        
        let audioBox = document.createElement('div');
        audioBox.style.width = 0;
        audioBox.style.height = 0;
        audioBox.style.overflow = 'hidden';
        audioBox.appendChild(audioElement);
        document.body.appendChild(audioBox);
    }
    this.audio = audioElement;

    audioElement = document.getElementById(this.options.audioNegativeId);
    if ( ! audioElement) {
        audioElement = document.createElement('audio');
        audioElement.setAttribute('id', this.options.audioNegativeId);
        audioElement.setAttribute('src', this.options.audioNegativeUrl);
        audioElement.setAttribute('preload', true);
        // audioElement.setAttribute('autoplay', true);
        
        let audioBox = document.createElement('div');
        audioBox.style.width = 0;
        audioBox.style.height = 0;
        audioBox.style.overflow = 'hidden';
        audioBox.appendChild(audioElement);
        document.body.appendChild(audioBox);
    }
    this.audioNegative = audioElement;
};

/**
 * load the images and audio
 */
Wings.prototype.preload = function() {
    let images = [];

    let keys = ['images03', 'images46', 'images710', 'imagesNegative'];
    ['add-score-0-3', 'add-score-4-6', 'add-score-7-10', 'add-score-negative'].forEach((t, index) => {
        for (let i = 1; i <= 90; i++) {
            let url = 'images/wings/' + t + '/fs8/' + ('00' + i).slice(-3) + '.png';
            images.push({
                key: keys[index],
                url: url
            });
        }
    });

    this.options.frameCount = 90;

    let me = this;
    let _loadImage = function(index) {
        if (index == images.length) return;
        let k = images[index].key;
        let img = new Image();
        img.addEventListener('load', function() {
            me[k].push(img);
            _loadImage(index + 1);
        });
        img.src = images[index].url;
    };
    _loadImage(0);
};

/**
 * @param {Image} the user's avatar image
 * @param {name} the user's name
 * @param {score} the user's score
 * @return {void}
 */
Wings.prototype.pushAnimation = function(avatarImage, name, score) {
    this.q.push({
        avatarImage: avatarImage,
        name: name,
        score: score
    });
    if (! this.isAnimating) this.showAnimation();
};

/**
 * Show the animation
 */
Wings.prototype.showAnimation = function() {
    let obj = this.q.shift();
    if (! obj) {
        this.hideAnimation();
        return;
    }

    let avatarImage = obj.avatarImage;
    let name = obj.name;
    let score = parseInt(obj.score);
    let scoreString = score;

    this.isAnimating = true;
    if (score < 0) {
        this.audioNegative.currentTime = 0;
        const ret = this.audio.play();
        if (ret && (typeof ret.then === 'function')) {
            ret.catch(err => {
                console.log('can not play audio');
            });
        };
        scoreString = scoreString;
        this.images = this.imagesNegative;
    } else {
        this.audio.currentTime = 0;
        const ret = this.audio.play();
        if (ret && (typeof ret.then === 'function')) {
            ret.catch(err => {
                console.log('can not play audio');
            });
        };
        scoreString = '+' + scoreString;
        if (0 <= score && score <= 3) {
            this.images = this.images03;
        } else if (4 <= score && score <= 6) {
            this.images = this.images46;
        } else {
            this.images = this.images710;
        }
    }
    let start = 0;
    let me = this;
    this.canvas.style.display = 'block';

    let canvasWidth = +(this.canvas.getAttribute('width'));
    let canvasHeight = +(this.canvas.getAttribute('height'));
    let imageWidth = this.options.imageWidth;
    let imageHeight = this.options.imageHeight;
    
    let ctx = this.canvas.getContext('2d');

    const frameCount = this.options.frameCount;
    const fps = 60;
    const frame = 1000 / fps;

    this.options.duration = frameCount / fps * 1000;

    // Avatar image
    const innerRadius = 75;
    const outerRadius = 81;
    let centerx = canvasWidth / 2;
    let centery = this.options.imageTop + outerRadius;
    
    let gradient = ctx.createLinearGradient(-outerRadius, -outerRadius, outerRadius, outerRadius);
    gradient.addColorStop(0, '#EEC03F');
    gradient.addColorStop(0.33, '#F9E695');
    gradient.addColorStop(1.0, '#DFAE28');

    // score
    const scoreCenterX = canvasWidth / 2;
    const scoreCenterY = this.options.imageTop + 219;

    // name
    const nameCenterX = canvasWidth / 2;
    const nameCenterY = this.options.imageTop + 319;

    ctx.clearRect(0, 0, canvasWidth, canvasHeight);
    

    let _draw = function(ts) {
        if (! start) start = ts;
        let delta = (ts - start);

        if (delta > me.options.duration + me.options.stillDuration) {
            if (me.q.length > 0) {
                me.showAnimation();
            } else {
                me.hideAnimation();
                me.isAnimating = false;
            }
            return;
        }

        // fullscreen background mask
        // alpha from 0 - 0.8, frame from 0 - 18
        let maskAlpha = (0.8 - 0) * (delta / (frame * 18));
        if (maskAlpha > 0.8) maskAlpha = 0.8;
        maskAlpha = maskAlpha.toFixed(4);
        // console.log(delta, delta / (frame * 18));
        ctx.save();
        ctx.clearRect(0, 0, canvasWidth, canvasHeight);
        ctx.fillStyle = 'rgba(0, 0, 0, ' + maskAlpha + ')';
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        ctx.restore(); 

        if (avatarImage) {
            // avatar scale 
            // frame 0 to 24, scale from 0.8 to 1.0
            let avatarScale = 0.8 + 0.2 * (delta / (frame * 24));
            if (avatarScale > 1) avatarScale = 1.0;
            avatarScale = avatarScale.toFixed(4);

            // avatar alpha
            // frame 10 to 18, alpha 0 - 1.0
            let avatarAlpha = 0;
            if (delta < frame * 10) {
                // nothing to do
            } else if (frame * 10 <= delta && delta <= frame * 18) {
                avatarAlpha = 1.0 * (delta - frame * 10) / (frame * 8);
            } else {
                avatarAlpha = 1.0;
            }
            if (avatarAlpha > 1.0) avatarAlpha = 1.0;
            avatarAlpha = avatarAlpha.toFixed(4);

            ctx.save();
            ctx.translate(centerx, centery);
            ctx.scale(avatarScale, avatarScale);
            ctx.globalAlpha = avatarAlpha;

            ctx.beginPath();
            ctx.fillStyle = gradient;
            ctx.arc(0, 0, outerRadius, 0, Math.PI * 2);
            ctx.fill();

            ctx.beginPath();
            ctx.fillStyle = '#FFFFFF';
            ctx.arc(0, 0, innerRadius, 0, Math.PI * 2);
            ctx.fill();

            ctx.beginPath();
            ctx.arc(0, 0, innerRadius, 0, Math.PI * 2);
            ctx.clip();
            
            if (avatarImage) ctx.drawImage(avatarImage, 0, 0, avatarImage.naturalWidth, avatarImage.naturalWidth, -innerRadius, -innerRadius, innerRadius * 2, innerRadius * 2);

            ctx.restore();
        }
        let index = 0;
        let percent = 0;
        if (delta < me.options.duration) {
            percent =  delta / me.options.duration;
            index = Math.round(me.images.length * percent);
            if (index > me.images.length - 1) index = me.images.length - 1;
        } else if (delta > me.options.duration && delta <= me.options.duration + me.options.stillDuration) {
            percent = 1;
            index = me.images.length - 1;
        } 
        ctx.save();
        if (me.images[index]) {
            ctx.drawImage(me.images[index], 0, 0, me.options.imageWidth, me.options.imageHeight, me.options.imageLeft, me.options.imageTop, me.options.imageWidth, me.options.imageHeight);
        }
        ctx.restore();

        // Score
        // frame: 0 - 24, scale: 0.8 - 1.0
        // frame: 10 - 18, appha: 0 - 1.0
        ctx.save();
        ctx.translate(scoreCenterX, scoreCenterY);
        
        let scoreScale = 0.8 + 0.2 * (delta / (frame * 24));
        if (scoreScale > 1) scoreScale = 1.0;
        scoreScale = scoreScale.toFixed(4);
        ctx.scale(scoreScale, scoreScale);
            
        let scoreAlpha = 0.0;
        if (delta < frame * 10) {
            // nothing to do
        } else if (frame * 10 <= delta && delta <= frame * 18) {
            scoreAlpha = 1.0 * (delta - frame * 10) / (frame * 8);
        } else {
            scoreAlpha = 1.0;
        }
        if (scoreAlpha > 1) scoreAlpha = 1.0;

        scoreAlpha = scoreAlpha.toFixed(4);
        ctx.font= '36px Arial, Tahoma, sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = 'rgba(237, 202, 92, ' + scoreAlpha + ')';
        ctx.fillText(scoreString, 0, 0);

        ctx.restore();


        // Name
        // frame: 14 to 24, alpha: 0 - 1.0
        let nameAlpha = 0;
        if (delta < frame * 14) {
            // nothing to do
        } else if (frame * 14 <= delta && delta <= frame * 24) {
            nameAlpha = 1.0 * (delta - frame * 14) / (frame * 10);
        } else {
            nameAlpha = 1.0;
        }

        if (nameAlpha > 1.0) nameAlpha = 1.0;
        nameAlpha = nameAlpha.toFixed(4);

        ctx.save();
        ctx.translate(nameCenterX, nameCenterY);

        ctx.font= '48px Arial, Tahoma, sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = 'rgba(237, 202, 92, ' + nameAlpha + ')';
        ctx.fillText(name, 0, 0);
        ctx.restore();

        window.requestAnimationFrame(_draw);
    };
    window.requestAnimationFrame(_draw);
};

Wings.prototype.hideAnimation = function() {
    this.canvas.style.display = 'none';
    this.isAnimating = false;
    this.q.splice(0);
};

Wings.prototype.test = function() {
};

export default Wings;